export class DeleteAccountRequest {
  public password: string;
}
